<tr-connection-alert></tr-connection-alert>
<ionic-alerts-outlet></ionic-alerts-outlet>
<router-outlet></router-outlet>
<tablesready-consent-banner></tablesready-consent-banner>
<tr-stale-tab-overlay></tr-stale-tab-overlay>
